import { Box, Flex, customStyled } from '@mafc/trolly';
import { RoundCornerButton } from 'common/styled/Button.style';

export const Title = customStyled(Box)(({ theme: { fontWeights } }) => ({
  textAlign: 'center',
  fontWeight: fontWeights[8],
}));

export const DriverTipDrawer = customStyled(Flex)(() => ({
  flexDirection: 'column',
  height: 'calc(100% - 72px)',
}));

export const ComingSoon = customStyled(Box)(({ theme: { fontSizes, space } }) => ({
  fontSize: fontSizes[2],
  marginTop: space[4],
  textAlign: 'center',
}));

export const GoItButton = customStyled(RoundCornerButton)(({ theme: { space } }) => ({
  marginBottom: space[3],
}));
